import Loader from "components/common/loader";
import { SURVEY_COMMENTS } from "constants/endpoints";
import {
  getOrganizations,
  createOrganizations,
  updateOrganizations,
  deleteOrganization,
  deleteBulkOrganizations,
} from "containers/community/api";
import {
  Anchor,
  ArrowLeft,
  CalendarBlank,
  Hash,
  MapPinLine,
  Minus,
  Pencil,
  Plus,
  Trash,
  User,
  ChatCircleText,
  Phone,
  AddressBook,
  ChatCircle,
  CaretRight,
  CaretDown,
} from "phosphor-react";
import { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { capitalizeName, formatAddress } from "utils/common";
import "../survey/survey.scss";
import * as Yup from "yup";
import Input from "components/common/input";
import SelectComponent from "components/common/select";
import DateInput from "components/common/date-picker";
import { ErrorMessage, Formik } from "formik";
import { useLocation } from "react-router-dom";
import { getEncounterHistory, startEncounter } from "containers/community/api";
import { COMMUNITY_OUTREACH_PATH } from "constants/routePaths";
import { initialMetaForTable } from "constants/common";
import TableWrapper from "components/common/table-wrapper";
import { EncounterLabels } from "constants/community";
import { discardEncounter, getSurveyComments } from "containers/survey/api";
import { get, put } from "services/network";

import CustomModal from "components/common/modal";
import AddOrganizationForm from "./AddOrganizationForm";
import Tooltip from "components/common/tooltip";

const HeaderCard = ({ icon, title, subTitle }) => {
  return (
    <div className="d-flex align-items-center header-card">
      <div className="d-flex flex-column justify-content-between ">
        <span className="heading-xs title ">{title}</span>
        <span
          className="heading-smb sub-title small  fw-semibold "
          style={{ whiteSpace: "normal", wordBreak: "break-word" }}
        >
          {subTitle}
        </span>
      </div>
    </div>
  );
};

const EncounterHistory = () => {
  const navigate = useNavigate();
  const { memberId } = useParams();
  const location = useLocation();
  const [organization, setOrganization] = useState(() => {
    const storedOrg = localStorage.getItem("currentOrganization");
    return (
      location.state?.organization || (storedOrg ? JSON.parse(storedOrg) : {})
    );
  });
  const [comment, setComment] = useState("");
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [history, setHistory] = useState([]);
  const [meta, setMeta] = useState({
    ...initialMetaForTable,
  });
  const [showDetailsId, setshowDetailsId] = useState("");
  const [activeTab, setActiveTab] = useState("organizationInfo");
  const [refreshPage, setRefreshPage] = useState(false);
  const [isOrganizationModalVisible, setOrganizationModalVisible] = useState(
    false
  );
  const [currentOrganizationEdit, setcurrentOrganizationEdit] = useState("");
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [selected, setSelected] = useState("");
  const [encounterList, setEncounterList] = useState([]);

  const handleEncounterStart = async (org) => {
    try {
      const result = await startEncounter(org.id);
      if (result["encounter"]) {
        const encounterID = result.encounter.id;
        localStorage.setItem("currentOrganization", JSON.stringify(org));
        navigate(
          `${COMMUNITY_OUTREACH_PATH}/${org.name.replace(
            " ",
            "-"
          )}-encounter/${encounterID}`,
          {
            state: {
              keyContacts: org.organization_contacts || [],
              organizationInfo: org,
            },
          }
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getSurveyComments = async () => {
    try {
      if (organization?.id) {
        const result = await get(
          `${SURVEY_COMMENTS}?filter[commentable_type]=Member&filter[commentable_id]=${organization.id}`,
          true
        );
        setComments(result);
      }
    } catch (error) {
      console.error("Error fetching survey comments:", error);
    }
  };

  const updateSurveyComment = async (content) => {
    try {
      const payload = {
        comment: {
          content,
        },
      };

      const result = await put(
        `${SURVEY_COMMENTS}/${organization.id}`,
        payload,
        true
      );
      return result;
    } catch (error) {
      console.error("Error updating comment:", error);
    }
  };

  const handleBlur = async (content) => {
    await updateSurveyComment(content);
  };

  useEffect(() => {
    if (organization?.id) {
      getSurveyComments();
    }
  }, [organization]);

  const fetchEncounterHistory = useCallback(async () => {
    setLoading(true);
    try {
      if (organization?.id) {
        const result = await getEncounterHistory(organization.id);
        if (result["encounters"]) {
          const data = result?.encounters;
          setHistory(data);
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [organization, refreshPage]);

  useEffect(() => {
    fetchEncounterHistory();
  }, [fetchEncounterHistory]);

  const handleCloseOrganizationModal = () => {
    setOrganizationModalVisible(false);
    setcurrentOrganizationEdit("");
  };

  const handleOpenOrganizationModal = () => {
    setOrganizationModalVisible(true);
  };
  const handleRefreshPage = () => {
    setRefreshPage((pre) => !pre);
  };
  const handleOrganizationSubmission = async (organization, setSubmitting) => {
    const isEditMode = Boolean(organization);
    try {
      if (typeof currentOrganizationEdit === "object") {
        const { id, address, organization_contacts, ...rest } = organization;

        const payload = {
          ...rest,
        };

        const result = await updateOrganizations(
          {
            ...(isEditMode
              ? { community_engagement: payload }
              : { community_engagements: payload }),
          },
          id
        );

        if (result) {
          handleCloseOrganizationModal();
          handleRefreshPage();
        }
      } else {
        const payload = {
          ...organization,
        };

        const result = await createOrganizations({
          community_engagement: payload,
        });
        if (result) {
          handleCloseOrganizationModal();
          handleRefreshPage();
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setSubmitting(false);
    }
  };

  const handleOpenDeleteModal = (id) => {
    setSelected(id);
    setShowDeleteConfirm(true);
  };

  const handleCloseDeleteModal = () => {
    setSelected("");
    setShowDeleteConfirm(false);
  };

  const handleDiscard = async (encounterID) => {
    try {
      await discardEncounter(encounterID);

      setHistory((prevHistory) =>
        prevHistory.filter((encounter) => encounter.id !== encounterID)
      );

      setEncounterList((prevList) =>
        prevList.filter((encounter) => encounter.id !== encounterID)
      );

      localStorage.setItem(
        "encounterList",
        JSON.stringify(
          encounterList.filter((encounter) => encounter.id !== encounterID)
        )
      );
    } catch (error) {
      console.error("Error discarding encounter:", error);
    }
  };

  const handleDeleteConfirm = () => {
    handleDiscard(selected);
    handleCloseDeleteModal();
  };

  if (!organization || !Object.keys(organization).length) {
    return (
      <div>
        Error: Organization data not found. Please go back and try again.
      </div>
    );
  }

  return (
    <>
      <div className="row ms-4">
        <div className="col">
          {loading ? (
            <div className="loader-wrapper">
              <Loader />
            </div>
          ) : (
            <>
              <div className="row">
                <div className="col-12 col-sm-9 pe-sm-5">
                  <div className="main-header pb-0">
                    <div className="arrow-and-content">
                      <ArrowLeft
                        className="opacity-50 mb-2 me-2 cursor-pointer"
                        size={24}
                        onClick={() => navigate(-1)}
                      />
                      <h3 className="space">
                        {capitalizeName(organization.name)}'s Encounter History
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-md-7 survey-table-wrapper">
                  <TableWrapper
                    isLoading={loading}
                    searchFeild={false}
                    pageSize={meta.perPage}
                    totalListCount={history.length}
                    actionButtons={[
                      {
                        label: "Start Encounter",
                        classes: "secondary-btn",
                        handleClick: () => handleEncounterStart(organization),
                      },
                    ]}
                  >
                    <div className="container-fluid ">
                      <div className=" overflow-scroll boarder-radius-20px">
                        <table className="table table-rows ">
                          <thead className="table-header ">
                            <tr>
                              <th>
                                <div className="form-check p-0 mb-0"></div>
                              </th>
                              <th>Submission Date</th>
                              <th>Submitted by</th>
                              <th>Status</th>
                              <th></th>
                            </tr>
                          </thead>

                          <tbody className="table-body">
                            {history?.map((encounter, encounterIndex, arr) => {
                              const showQuestions =
                                encounterIndex === showDetailsId;
                              const isPendingOrInProgress =
                                encounter.status === "pending" ||
                                encounter.status === "in_progress";
                              return (
                                <>
                                  <tr key={encounterIndex}>
                                    <td>
                                      <div
                                        className={`d-flex justify-content-between align-items-center ms-3 me-3 ${
                                          showQuestions ? "active" : ""
                                        }`}
                                        onClick={() => {
                                          if (showQuestions) {
                                            setshowDetailsId("");
                                          } else {
                                            setshowDetailsId(encounterIndex);
                                          }
                                        }}
                                      >
                                        {showQuestions ? (
                                          <div className="cursor-pointer">
                                            <CaretDown size={20} />
                                          </div>
                                        ) : (
                                          <div className="cursor-pointer">
                                            <CaretRight size={20} />
                                          </div>
                                        )}
                                      </div>
                                    </td>
                                    <td className="fw-bold  ">
                                      {encounter.updated_at}
                                    </td>
                                    <td className=" ">
                                      {capitalizeName(
                                        encounter?.updated_by_jsonb?.name
                                      ) || "N/A"}
                                    </td>

                                    <td className=" ">
                                      <div
                                        className={`status ${
                                          encounter.status === "complete"
                                            ? "Completed"
                                            : encounter.status === "in_progress"
                                            ? "Excluded"
                                            : "inProgress"
                                        } ps-1 pe-1`}
                                      >
                                        {encounter.status === "complete"
                                          ? "Completed"
                                          : encounter.status === "in_progress"
                                          ? "In Progress"
                                          : "In Progress"}
                                      </div>
                                    </td>
                                    <td>
                                      {encounter.status !== "complete" && (
                                        <Tooltip title={"Delete"}>
                                          <Trash
                                            size={24}
                                            className="ms-3 opacity-50"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => {
                                              handleOpenDeleteModal(
                                                encounter.id
                                              );
                                            }}
                                          />
                                        </Tooltip>
                                      )}
                                    </td>
                                  </tr>
                                  {showQuestions ? (
                                    <tr>
                                      <td
                                        className={`card-footer ${
                                          showQuestions ? "active" : ""
                                        }`}
                                        colSpan={5}
                                      >
                                        <div
                                          onClick={() => {
                                            if (showQuestions) {
                                              setshowDetailsId("");
                                            } else {
                                              setshowDetailsId(encounterIndex);
                                            }
                                          }}
                                          className="cursor-pointer"
                                        >
                                          {showQuestions &&
                                            Object.keys(EncounterLabels)?.map(
                                              (key, index, arr) => (
                                                <div
                                                  className="d-flex flex-column ps-4 pt-3 m-3 expand-card"
                                                  key={key}
                                                >
                                                  <p className="opacity-50">{`Question No.${index +
                                                    1} of ${arr.length}`}</p>
                                                  <h6>
                                                    {EncounterLabels[key]}
                                                  </h6>

                                                  <p className="opacity-50">
                                                    {key === "careManager"
                                                      ? encounter?.answers
                                                          ?.careManager?.name ||
                                                        "N/A"
                                                      : encounter?.answers?.[
                                                          key
                                                        ] || "N/A"}
                                                  </p>
                                                </div>
                                              )
                                            )}
                                          {showQuestions && <hr />}
                                        </div>
                                      </td>
                                    </tr>
                                  ) : null}
                                </>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </TableWrapper>
                </div>
                <div className="col-12 col-md-4 survey-info">
                  <div className="d-flex justify-content-between align-items-center">
                    <h4 className="fw-bold mb-0">Key Details</h4>
                    <div className=" rounded-circle p-2  bg-body-secondary">
                      <Pencil
                        size={24}
                        onClick={handleOpenOrganizationModal}
                        className="cursor-pointer  "
                      />
                    </div>
                  </div>
                  <div className="my-4 d-flex justify-content-between gap-3">
                    <button
                      className={` w-50 ${
                        activeTab === "organizationInfo"
                          ? "primary-btn"
                          : "secondary-btn"
                      }`}
                      onClick={() => setActiveTab("organizationInfo")}
                    >
                      Organization Info
                    </button>
                    <button
                      className={` w-50 ${
                        activeTab === "keyContacts"
                          ? "primary-btn"
                          : "secondary-btn"
                      }`}
                      onClick={() => setActiveTab("keyContacts")}
                    >
                      Key Contacts
                    </button>
                  </div>
                  {activeTab === "organizationInfo" ? (
                    <>
                      {/* Basic Info */}
                      <div className="w-100 p-4 border border-black border-opacity-10 border-2 bg-card-secondary rounded-3">
                        <h5 className="fw-bold">Basic Info</h5>
                        <div className="mt-1 d-flex flex-column gap-3">
                          <div className="row">
                            <div className="col-12">
                              <HeaderCard
                                title="Name"
                                subTitle={organization.name || "N/A"}
                              />
                            </div>
                            <div className="col-12">
                              <HeaderCard
                                title="Type"
                                subTitle={
                                  capitalizeName(
                                    organization.organization_type
                                  ) || "N/A"
                                }
                              />
                            </div>
                            <div className="col-6">
                              <HeaderCard
                                title="Parent Company"
                                subTitle={organization.owner || "N/A"}
                              />
                            </div>
                          </div>
                          <HeaderCard
                            title="Website"
                            subTitle={organization.website || "N/A"}
                          />
                          <HeaderCard
                            title="County"
                            subTitle={organization?.address?.county || "N/A"}
                          />
                          <HeaderCard
                            title="Address"
                            subTitle={
                              formatAddress(organization.address) || "N/A"
                            }
                          />
                        </div>
                      </div>

                      {/* Contact Info */}
                      <div className="mt-3 w-100 p-4 border border-black border-opacity-10 border-2 bg-card-secondary rounded-3">
                        <h5 className="fw-bold">Contact Info</h5>
                        <div className="mt-1 d-flex flex-column gap-3">
                          <HeaderCard
                            title="Email"
                            subTitle={organization.email || "N/A"}
                          />
                          <HeaderCard
                            title="Phone"
                            subTitle={organization.phone || "N/A"}
                          />
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className="d-flex flex-wrap gap-3">
                      {organization.organization_contacts?.length > 0 ? (
                        organization.organization_contacts.map((contact) => (
                          <div
                            key={contact.id}
                            className="w-100 p-4 border border-black border-opacity-10 border-2 bg-card-secondary rounded-3"
                          >
                            <h5 className="fw-bold">{contact.name || "N/A"}</h5>
                            <div className="mt-1 d-flex flex-column gap-3">
                              <HeaderCard
                                title="Email"
                                subTitle={contact.email || "N/A"}
                              />
                              <div className="row">
                                <div className="col-6">
                                  <HeaderCard
                                    title="Phone"
                                    subTitle={contact.phone || "N/A"}
                                  />
                                </div>
                                <div className="col-6">
                                  <HeaderCard
                                    title="Designation"
                                    subTitle={contact.designation || "N/A"}
                                  />
                                </div>
                              </div>
                              {contact.primary && (
                                <span className="badge bg-success">
                                  Primary Contact
                                </span>
                              )}
                            </div>
                          </div>
                        ))
                      ) : (
                        <p>No contacts available.</p>
                      )}
                    </div>
                  )}
                  <div className="mt-3 w-100 p-4 border border-black border-opacity-10 border-2 bg-card-secondary rounded-3">
                    <h5 className="fw-bold">Add Notes</h5>
                    <div className="mt-1 d-flex flex-column gap-3">
                      <Input
                        type="textarea"
                        name="note_box"
                        value={comment?.content}
                        onChange={(e) => setComment(e.target.value)}
                        onBlur={() => handleBlur(comment)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
          {isOrganizationModalVisible && (
            <CustomModal
              size="sm"
              show
              onHide={handleCloseOrganizationModal}
              heading={`${organization ? "Edit" : "Add"} Organization`}
            >
              <AddOrganizationForm
                handleSubmittion={handleOrganizationSubmission}
                handleClose={handleCloseOrganizationModal}
                currentOrganizationEdit={organization}
              />
            </CustomModal>
          )}
        </div>
      </div>
      {showDeleteConfirm && (
        <CustomModal
          size="sm"
          show
          onHide={handleCloseDeleteModal}
          heading={`Confirmation`}
        >
          <div className="question-modal">
            <hr className="custom-modal-line mt-0 " />

            <form className="form-main" onSubmit={() => {}}>
              <h6>Are you sure you want to delete this encounter?</h6>

              <hr className="custom-modal-line mt-4" />

              <div className="action gap-2">
                <button
                  className="secondary-btn w-50"
                  type="button"
                  onClick={handleCloseDeleteModal}
                >
                  Cancel
                </button>
                <button
                  className="primary-btn w-50"
                  type="button"
                  onClick={handleDeleteConfirm}
                >
                  Confirm
                </button>
              </div>
            </form>
          </div>
        </CustomModal>
      )}
    </>
  );
};

export default EncounterHistory;
